import { isValidElement, ReactNode } from 'react';
import { getComponentProps, renderChildren } from '@fiverr-private/ui_utils';
import { TabContextType, TabInternalProps, TabProps } from '../types';
import { tabId, tabPanelId } from '../helpers';

export const renderTabChild =
    ({ isStretched, variant, placement, idPrefix, selectedIndex, setSelectedIndex, tabsRef }: TabContextType) =>
    (child: ReactNode, index: number) => {
        if (!isValidElement(child)) return null;

        const isDisabled = !!getComponentProps(child).isDisabled;
        const isSelected = index === selectedIndex && !isDisabled;

        tabsRef.current[index] = {
            index,
            isSelected,
            isDisabled,
            wasSelected: tabsRef.current[index]?.wasSelected ?? isSelected,
        };

        return renderChildren(child, {
            isSelected,
            isDisabled,
            isStretched,
            variant,
            placement,
            id: tabId(idPrefix, index),
            panelId: tabPanelId(idPrefix, index),
            onClick: () => setSelectedIndex(index),
        } satisfies Omit<TabProps & TabInternalProps, 'children'>);
    };
